export enum EaseType {
    LINEAR = 'linear',
    EASE_IN = 'easeIn',
    EASE_OUT = 'easeOut',
    EASE_IN_BOUNCE = 'easeInBounce',
    EASE_OUT_BOUNCE = 'easeOutBounce'
}
